<template>
  <section class="sfgrd-main-wrap">
    <tk-page
      :page-config="objPageConfig"
      :obj-table="objTable"
      :obj-form="objSelectForm"
      :obj-buttons="objButtons"
      @onSearch="queryData"
      @onReset="resetFields"
    >
    </tk-page>
    <dialog-approval ref="dialogApproval" />
  </section>
</template>

<script>
import { mapActions } from "vuex";
import { APPROVAL_LEVEL_OPTIONS, vehicleMap } from "@/common/js/constConfig.js";
import DialogApproval from "./components/DialogApproval.vue";

export default {
  components: {
    DialogApproval,
  },
  data() {
    return {
      rules: {
        reason: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      objApprovalDialog: {
        dialogVisible: false,
        row: {},
        form: {
          orderId: "",
          approvalState: "",
          reason: "",
        },
      },
      objPageConfig: {
        fixHeight: 162, // 获取用户屏幕高度：减去的130是页面中layout之类固定的高度(pagenation+顶部bar)
        // fillLayout: true, // 是否自动填充高度 默认true
        // isScrollFixed: true, //是否table滚动时fixed 默认false
        // isShowColumnSetting:false,// 是否显示定制列 默认显示 true
        // isShowTableConfig:false, // 是否显示表格个性化操作栏 默认显示 true
        columnCacheKey: "SAAS-OrderBiddingApproval", // 需缓存的key，无则不缓存 ！！important
        // isEmptyFullScreen: false, // 无数据时高度占满高度 默认 true
        // defaultTableSize: "mini", // 默认配置 默认为small (mini small)
        isDefaultSearch: true, // 是否默认查询 默认不查询 false
        pageTitle: "竞价找车审批列表", // 页面标题-用户神策埋点
      },
      objSelectForm: {
        size: "mini",
        showSearchBtn: () => {
          return this.showBtns["OrderBiddingApproval_query"];
        },
        model: {
          orderId: "",
          srcAddr: "", // 始发地
          destAddr: "", // 目的地
          planDepartStartTm: "", // 计划发车时间开始，格式 2022-11-29 00:00:00
          planDepartEndTm: "",
          approvalState: "",
          arrTime: [],
          approvalLevel: "",
        },
        arrFormItem: [
          {
            label: "订单号",
            prop: "orderId",
            element: "el-input",
          },
          {
            label: "计划发车时间",
            prop: "arrTime",
            element: "el-date-picker",
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "yyyy-MM-dd",
            format: "yyyy-MM-dd",
            isRange: true,
            editable: false,
          },
          {
            label: "发货地址",
            prop: "srcAddr",
            element: "el-input",
          },
          {
            label: "收货地址",
            prop: "destAddr",
            element: "el-input",
          },
          // 审批状态 0待审批 1审批通过 2审批拒绝
          {
            label: "审批状态",
            prop: "approvalState",
            element: "el-select",
            options: [
              { value: "", label: "全部" },
              { value: "0", label: "待审批" },
              { value: "1", label: "通过" },
              { value: "2", label: "驳回" },
            ],
          },
          {
            label: "审批等级",
            prop: "approvalLevel",
            element: "el-select",
            options: [
              { value: "", label: "全部" },
              ...APPROVAL_LEVEL_OPTIONS
            ],
          },
        ],
      },
      objButtons: {
        arrBtnItem: [],
      },
      objTable: {
        loading: false,
        height: "500px", // 设置无数据占满时需设置默认高度
        "row-key": "orderId",
        objPage: {
          size: 10,
          total: 0,
          pn: 1,
          pnFunc: (pn) => {
            this.objTable.objPage.pn = pn;
            this.searchList();
          },
          pzFunc: (size) => {
            this.objTable.objPage.size = size;
            this.searchList();
          },
        },
        tableData: [],
        tableColumn: [
          {
            type: "index",
            field: "index",
            title: "序号",
            width: 50,
            fixed: true,
          },
          {
            field: "orderId",
            title: "订单号",
            minWidth: 140,
          },
          {
            field: "srcAddr",
            title: "线路",
            minWidth: 300,
            formatter: (row) => {
              return (
                <div>
                  <span class="point src"></span>
                  {row.srcAddr}
                  <br />
                  <span class="point dest"></span>
                  {row.destAddr}
                </div>
              );
            },
          },
          {
            field: "planDepartTmStr",
            title: "计划发车时间", // 查看详情
            minWidth: 140,
          },
          {
            field: "requireCategoryStr",
            title: "车型车长",
            minWidth: 140,
            overflowtooltip: true,
            formatter: (row) => {
              return `${this.mapVehicle(row.vehicleType)} / ${
                row.vehicleLength ? row.vehicleLength + "m" : "--"
              }`;
            },
          },
          {
            field: "approvalName",
            title: "审批人",
            minWidth: 100,
          },
          {
            field: "approvalTmStr",
            title: "审批时间",
            minWidth: 140,
            formatter: (row) => {
              return this.$commonUtil.dateFormatByMoment(row.approvalTmStr);
            },
          },
          {
            field: "approvalStateStr",
            title: "审批结果",
            minWidth: 80,
          },
          {
            field: "reason",
            title: "审批说明",
            minWidth: 160,
            overflowtooltip: true,
          },
          // {
          //   field: "expectPrice",
          //   title: "期望价格",
          //   minWidth: 80,
          // },
          {
            field: "bargainPrice",
            title: "报价",
            minWidth: 80,
          },
          {
            field: "floatingRatioStr",
            title: "浮动比例",
            minWidth: 80,
          },
          {
            type: "columnOperation",
            title: "操作",
            fixed: "right",
            width: 120,
            align: "center",
            showNum: 2,
            btns: (scope) => {
              return [
                {
                  name: "省区中控审核",
                  click: (scope) => {
                    this.handleApproval(scope.row);
                  },
                  show: (scope) => {
                    return (
                      this.showBtns["OrderBiddingApproval_ApprovalProvince"] &&
                      scope.row.approvalState === 0 &&
                      scope.row.approvalLevel === 1
                    );
                  },
                },
                {
                  name: "运营部负责人审批",
                  click: (scope) => {
                    this.handleApproval(scope.row);
                  },
                  show: (scope) => {
                    return (
                      this.showBtns["OrderBiddingApproval_ApprovalDepartment"] &&
                      scope.row.approvalState === 0 &&
                      scope.row.approvalLevel === 2
                    );
                  },
                },
                {
                  name: "总部中控审核",
                  click: (scope) => {
                    this.handleApproval(scope.row);
                  },
                  show: (scope) => {
                    return (
                      this.showBtns["OrderBiddingApproval_ApprovalHeadquarters"] &&
                      scope.row.approvalState === 0 &&
                      scope.row.approvalLevel === 3
                    );
                  },
                },
              ];
            },
          },
        ],
        events: {
          // "selection-change": this.handleSelectionChange,
        },
      },
      multipleSelection: [],
      vehicleMap: vehicleMap,
    };
  },
  computed: {
    showBtns() {
      let obj = {};
      let menuMap = this.$store.state.login.menuMap;
      if (menuMap && menuMap["OrderBiddingApproval"]) {
        let submenuList = menuMap["OrderBiddingApproval"].split("-");
        submenuList.forEach((item) => {
          obj[item] = true;
        });
      }
      return obj;
    },
  },
  mounted() {},
  methods: {
    ...mapActions([
      "orderBiddingApprovalServiceQueryPageApi",
    ]),
    queryData() {
      this.objTable.objPage.pn = 1;
      this.searchList();
    },
    // 查询列表数据
    searchList() {
      const oParam = {
        pageSize: this.objTable.objPage.size,
        pageNum: this.objTable.objPage.pn,
        ...this.handleParam(),
      };
      this.objTable.loading = true;
      this.orderBiddingApprovalServiceQueryPageApi(oParam)
        .then((oResp) => {
          this.objTable.tableData = oResp.rows;
          this.objTable.objPage.total = oResp.totalCount;
        })
        .catch(() => {
          this.objTable.tableData = [];
          this.objTable.objPage.total = 0;
        })
        .finally(() => {
          this.objTable.loading = false;
        });
    },
    resetFields() {},
    handleParam() {
      let oParam = Object.assign({}, this.objSelectForm.model);
      if (oParam.arrTime && oParam.arrTime.length > 1) {
        oParam.planDepartStartTm = oParam.arrTime[0] + " 00:00:00";
        oParam.planDepartEndTm = oParam.arrTime[1] + " 23:59:59";
      }
      delete oParam.arrTime;
      return oParam;
    },
    // E 页面组件相关
    handleApproval(row) {
      this.$refs.dialogApproval.openDialog({
        row: row,
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    mapVehicle(code) {
      let name = "";
      if (code) {
        this.vehicleMap.forEach((item) => {
          code == item.plVehicleCode && (name = item.plVehicleType);
        });
      }
      return name;
    },
  },
};
</script>
